<template>
  <div class="content-box">
    <header v-if="hasReport === true">
      <h2>学期编程学习统计</h2>
      <p class="sub">
        统计范围：
        <span>{{cnStartDate}}至{{cnEndDate}}</span>
      </p>
      <div class="avatar" :style="{backgroundImage: `url(${user.avatar_url})`}"></div>
      <h3>{{user.real_name}}</h3>
      <ul>
        <li class="count">
          <h4>累计上课数</h4>
          <p>{{court_count || '--'}}</p>
        </li>
        <li class="show">
          <h4>课堂表现</h4>
          <p>{{performance_type === '' ? '--' : {'1': '优秀', '2': '良好', '3': '合格', '4': '待改进'}[performance_type]}}</p>
        </li>
      </ul>
    </header>
    <ul class="content" v-if="hasReport === true">
      <title-section title="基本情况">
        <ul class="section-list">
          <chart-section title="任课老师及班级">
            <ul class="class">
              <li v-for="v of classData" :key="v.id">
                <span>{{v.teacher_name}}</span>
                {{v.class_name}}
              </li>
            </ul>
          </chart-section>
          <chart-section title="已开通课程包">
            <ul class="course">
              <li v-for="v of packageData" :key="v">{{v}}</li>
            </ul>
          </chart-section>
        </ul>
      </title-section>
      <!-- <title-section title="作品情况">
        <ul class="section-list">
          <chart-section title="本学期作品">
            <bus-pie-charts v-if="semesteWorks" :data="semesteWorks"></bus-pie-charts>
          </chart-section>
          <chart-section title="累计作品">
            <bus-pie-charts v-if="cumulativeWorks" :data="cumulativeWorks"></bus-pie-charts>
          </chart-section>
          <chart-section title="本学期星级作品分布">
            <bus-bar-charts v-if="starWorks" :data="starWorks"></bus-bar-charts>
          </chart-section>
        </ul>
      </title-section> -->
      <title-section title="能力维度">
        <ul class="section-list">
          <chart-section title="创新思维">
            <bus-line-charts v-if="creativeData" :data="creativeData"></bus-line-charts>
          </chart-section>
          <chart-section title="艺术设计">
            <bus-line-charts v-if="artisticData" :data="artisticData"></bus-line-charts>
          </chart-section>
          <chart-section title="逻辑思维">
            <bus-line-charts v-if="logicalData" :data="logicalData"></bus-line-charts>
          </chart-section>
          <chart-section title="编程技术">
            <bus-line-charts v-if="programmingData" :data="programmingData"></bus-line-charts>
          </chart-section>
          <chart-section>
            <bus-radar-charts v-if="radarData" :data="radarData"></bus-radar-charts>
          </chart-section>
        </ul>
      </title-section>
    </ul>
    <div class="no-works" v-if="hasReport === false">
      <no-work-img />
      <p>暂无数据</p>
    </div>
  </div>
</template>
<script>
import { Rate } from 'element-ui'
import { mapState, mapActions } from 'vuex'
import { get } from '@/utils/ajax'
import { isEmpty } from '@/utils'
import NoWorkImg from '@/assets/svg/no_works.svg'
import LineCharts from '@/components/LineCharts'
import BusLineCharts from './BusLineCharts'
import PieCharts from '@/components/PieCharts'
import BusPieCharts from '@/widgets/BusPieCharts'
import BarCharts from '@/components/BarCharts'
import BusBarCharts from './BusBarCharts'
import RadarCharts from '@/components/RadarCharts'
import BusRadarCharts from '@/widgets/BusRadarCharts'
export default {
  name: 'Report',
  created () {
    this.refresh()
  },
  data () {
    return {
      start_date: '',
      end_date: '',
      report_name: '',
      report_type: '',
      court_count: '',
      performance_type: '',
      packageData: [],
      cumulativeWorks: null, // 累计作品
      // semesteWorks: null, // 本学期作品
      starWorks: null, // 星级作品分布
      artisticData: null, // 艺术设计
      creativeData: null, // 创新思维
      logicalData: null, // 逻辑思维
      programmingData: null, // 编程能力
      radarData: null, // 编程能力
      hasReport: null
    }
  },
  computed: {
    ...mapState({
      user: state => state.user || {},
      classData: 'classData'
    }),
    cnStartDate () {
      if (!this.start_date) return '--'
      return new Date(this.start_date).Format('yyyy年MM月')
    },
    cnEndDate () {
      if (!this.end_date) return '--'
      return new Date(this.end_date).Format('yyyy年MM月')
    },
    user () {
      return this.$store.state.user || {}
    }
  },
  methods: {
    ...mapActions(['getCodemaoUserInfo', 'getClassList']),
    async refresh () {
      const { report_type } = await this.getReportInfo()
      if (report_type === 1) {
        this.hasReport = true
        this.getStudentCoure()
        this.getClassList()
        this.getPackageData()
        this.getWorksSituations()
        this.getWorksStar()
        this.getArtisticData()
        this.getLogicalData()
        this.getProgrammingData()
        this.getCreativeData()
        this.getRadarsData()
        this.getClassList()
        this.getCodemaoUserInfo()
      } else {
        this.hasReport = false
      }
    },
    async getStudentCoure () {
      const res = await get('/edu/wap/report/student/course')
      Object.entries(res).forEach(([k, v]) => {
        this[k] = v
      })
    },
    async getReportInfo () {
      const res = await get('/edu/wap/report/info')
      Object.entries(res).forEach(([k, v]) => {
        this[k] = v
      })
      return res
    },
    async getPackageData () {
      this.packageData = await get('/edu/wap/report/student/packages')
    },
    async getWorksSituations () {
      const { cumulative_work
        // semeste_work
      } = await get(
        '/edu/wap/report/student/works/situations'
      )
      if (cumulative_work.total) this.cumulativeWorks = cumulative_work
      // if (semeste_work.total) this.semesteWorks = semeste_work
    },
    async getWorksStar () {
      const {
        first_star_count,
        second_star_count,
        third_star_count,
        fouth_star_count,
        fifth_star_count
      } = await get('/edu/wap/report/student/works/star/info')
      if (
        first_star_count ||
        second_star_count ||
        third_star_count ||
        fouth_star_count ||
        fifth_star_count
      ) {
        this.starWorks = [
          { value: first_star_count },
          { value: second_star_count },
          { value: third_star_count },
          { value: fouth_star_count },
          { value: fifth_star_count }
        ]
      }
    },
    async getArtisticData () {
      const { avg_score, wroks } = await get(
        '/edu/wap/report/student/ability/artistic/dimensions'
      )
      if (wroks) {
        this.artisticData = {
          score: avg_score,
          data: wroks,
          name: 'artistic'
        }
      }
    },
    async getCreativeData () {
      const { avg_score, wroks } = await get(
        '/edu/wap/report/student/ability/creative/dimensions'
      )
      if (wroks) {
        this.creativeData = {
          score: avg_score,
          data: wroks,
          name: 'creative'
        }
      }
    },
    async getLogicalData () {
      const { avg_score, wroks } = await get(
        '/edu/wap/report/student/ability/logical/dimensions'
      )
      if (wroks) {
        this.logicalData = {
          score: avg_score,
          data: wroks,
          name: 'logical'
        }
      }
    },
    async getProgrammingData () {
      const { avg_score, wroks } = await get(
        '/edu/wap/report/student/ability/programming/dimensions'
      )
      if (wroks) {
        this.programmingData = {
          score: avg_score,
          data: wroks,
          name: 'programming'
        }
      }
    },
    async getRadarsData () {
      const res = await get('/edu/wap/report/student/ability/radars')
      if (!isEmpty(res.claz) || !!isEmpty(res.person) || !isEmpty(res.unit)) {
        this.radarData = res
      }
    }
  },
  components: {
    Rate,
    RadarCharts,
    BusRadarCharts,
    LineCharts,
    BusLineCharts,
    BarCharts,
    BusBarCharts,
    NoWorkImg,
    PieCharts,
    BusPieCharts,
    TitleSection: {
      functional: true,
      render (h, { props, children }) {
        return (
          <li class="title-section">
            <h5>{props.title}</h5>
            <div>{children}</div>
          </li>
        )
      }
    },
    ChartSection: {
      functional: true,
      render (
        h,
        {
          props: { title },
          children
        }
      ) {
        return (
          <li class="chart-section">
            {title && <h5>{title}</h5>}
            <div>{children}</div>
          </li>
        )
      }
    }
  }
}
</script>

<style lang="stylus" scoped>
header {
  background-position: center top;
  background-repeat: no-repeat;
  background-size: contain;
  background-image: url('~@/assets/images/bg.png');
  border-bottom: 10px solid #f4f4f4;
  flex-shrink: 0;
  flex-column-center();

  .sub {
    color: white;
    margin-bottom: 30px;
  }

  ul {
    display: flex;
    width: 100%;

    li {
      flex-grow: 1;
      flex-column-center();
    }

    p {
      font-size: 24px;
      color: #666;
    }
  }

  h3 {
    margin-bottom: 10px;
  }

  h4 {
    color: #999;
    margin-bottom: 5px;
  }
}

.no-works {
  margin-top: 87px;
  text-align: center;

  p {
    margin-top: -50px;
  }

  svg {
    width: 240px;
    // height 183px
  }
}

.content {
  max-width: 375px;
  overflow-x: hidden;
  padding-left: 15px;
  padding-right: 15px;
}

.title-section {
  padding-top: 30px;

  > h5 {
    font-size: 18px;
    color: #999;
    margin-bottom: 15px;
  }
}

.chart-section {
  box-shadow: 0 0 12px 0 rgba(101, 113, 117, 0.1);
  border-radius: 6px;
  padding: 15px;
  margin-bottom: 15px;

  > div:empty {
    text-align: center;
    font-size: 16px;
    color: #ccc;
    line-height: 160px;

    &:before {
      content: '';
      display: inline-block;
      width: 6.4vw;
      vertical-align: middle;
      height: 6.4vw;
      background-repeat: no-repeat;
      background-size: cover;
      margin-right: 2.66667vw;
      background-image: url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGcgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj48cGF0aCBmaWxsPSIiIGQ9Ik0tMTM2LTkxNGgzNzVWNDMxaC0zNzV6Ii8+PGcgZmlsbD0iIzAwMCIgZmlsbC1vcGFjaXR5PSIuMjUiIGZpbGwtcnVsZT0ibm9uemVybyI+PHBhdGggZD0iTTExLjczIDBDNS4yNTEgMCAwIDUuMjUxIDAgMTEuNzNjMCA2LjQ4IDUuMjUxIDExLjczIDExLjczIDExLjczIDYuNDggMCAxMS43My01LjI1IDExLjczLTExLjczQzIzLjQ2IDUuMjUxIDE4LjIxIDAgMTEuNzMgMHptNy4xMjggMTguODU4YTEwLjAyOCAxMC4wMjggMCAwIDEtMy4yMDUgMi4xNiA5Ljk4NCA5Ljk4NCAwIDAgMS0zLjkyMy43OTNjLTEuMzYgMC0yLjY4LS4yNjYtMy45MjItLjc5YTEwLjA5MSAxMC4wOTEgMCAwIDEtMy4yMDUtMi4xNiAxMC4wMjggMTAuMDI4IDAgMCAxLTIuMTYtMy4yMDYgMTAuMDAzIDEwLjAwMyAwIDAgMS0uNzkzLTMuOTI1YzAtMS4zNi4yNjUtMi42OC43OS0zLjkyMkExMC4wOTEgMTAuMDkxIDAgMCAxIDQuNiA0LjYwM2ExMC4wMjggMTAuMDI4IDAgMCAxIDMuMjA2LTIuMTYgMTAuMDAzIDEwLjAwMyAwIDAgMSAzLjkyNC0uNzkzYzEuMzYxIDAgMi42OC4yNjUgMy45MjMuNzkgMS4yLjUwOSAyLjI3NyAxLjIzNSAzLjIwNSAyLjE2YTEwLjAyOCAxMC4wMjggMCAwIDEgMi4xNiAzLjIwNmMuNTI3IDEuMjQ0Ljc5MyAyLjU2My43OTMgMy45MjRhMTAuMDIzIDEwLjAyMyAwIDAgMS0yLjk1MyA3LjEyOHoiLz48cGF0aCBkPSJNMTQuNjcgMTcuNTM4YS44MjQuODI0IDAgMCAxLS44MjUtLjgyNUEyLjExNyAyLjExNyAwIDAgMCAxMS43MyAxNC42YTIuMTE3IDIuMTE3IDAgMCAwLTIuMTE0IDIuMTE0LjgyNC44MjQgMCAxIDEtMS42NSAwIDMuNzY4IDMuNzY4IDAgMCAxIDMuNzY0LTMuNzY0IDMuNzY4IDMuNzY4IDAgMCAxIDMuNzY1IDMuNzY0LjgyNC44MjQgMCAwIDEtLjgyNS44MjV6TTQuNDUgOC43NjFhMS4zNzUgMS4zNzUgMCAxIDAgMi43NDkgMCAxLjM3NSAxLjM3NSAwIDAgMC0yLjc1IDB6TTE2LjI1NSA4Ljc2MWExLjM3NSAxLjM3NSAwIDEgMCAyLjc1IDAgMS4zNzUgMS4zNzUgMCAwIDAtMi43NSAweiIvPjwvZz48L2c+PC9zdmc+');
    }

    &:after {
      content: '暂无数据';
    }
  }

  >>> .charts {
    height: 250px !important;
  }

  > h5 {
    &:before {
      vertical-align: bottom;
      margin-right: 10px;
      content: '';
      background-color: $themeColor;
      width: 2px;
      height: 16px;
      display: inline-block;
    }
  }
}

.section-list {
  .class {
    li {
      margin-bottom: 10px;

      &:last-child {
        margin-bottom: 0;
      }
    }

    span {
      margin-right: 40px;

      &:before {
        content: '';
        round(6px);
        background-color: $themeColor;
        opacity: 0.5;
        display: inline-block;
        margin-right: 10px;
        vertical-align: middle;
      }
    }
  }

  .course {
    max-height: 150px;
    overflow-y: scroll;
    -webkit-overflow-scrolling: touch;

    li {
      @extend .section-list .class li;
      @extend .section-list .class span;
    }
  }
}

.avatar {
  round(66px);
  background-color: #ccc;
  background-position: center center;
  background-size: cover;
  border: 3px solid white;
  margin-bottom: 10px;
}

h2 {
  margin-top: 22px;
  color: white;
  font-size: 24px;
  margin-bottom: 0;
}
</style>
